{
  "version": 1,
  "asset_id": "df6b5bf4-db2f-4b2d-b992-65241bad8cf0",
  "project_id": "7580f3ab-e7a4-418d-abe6-5eb616986e51",
  "url": "/__l5e/assets-v1/df6b5bf4-db2f-4b2d-b992-65241bad8cf0/white-metal-roof-crystal-river-fl-1600.webp",
  "r2_key": "a/v1/7580f3ab-e7a4-418d-abe6-5eb616986e51/df6b5bf4-db2f-4b2d-b992-65241bad8cf0/white-metal-roof-crystal-river-fl-1600.webp",
  "original_filename": "white-metal-roof-crystal-river-fl-1600.webp",
  "size": 82128,
  "content_type": "image/webp",
  "created_at": "2026-07-16T15:36:44Z"
}
